import { render } from "./UiEventConfig.vue?vue&type=template&id=351a2b50&scoped=true&lang=pug"
import script from "./UiEventConfig.vue?vue&type=script&lang=js"
export * from "./UiEventConfig.vue?vue&type=script&lang=js"

import "./UiEventConfig.vue?vue&type=style&index=0&id=351a2b50&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-351a2b50"]])

export default __exports__